<template lang="pug">
  v-flex 
    v-card
      v-card-title Motivos de traslados
        v-spacer
        v-text-field(v-model='search' append-icon='fa-search' label='Buscar unidad de medida' single-line hide-details)
        v-dialog(v-model='Motivos_de_traslado.dialog' max-width='500px')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
          v-card
            v-card-title
              span.headline {{ title }}
            v-card-text
              v-form(autocomplete='false')
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(v-model='data.nombre' label='Nombre')
                    v-flex(xs12)
                      v-text-field(v-model='data.código' label='Código')
            v-card-actions
              v-spacer
              v-btn(color='primary' @click='save()') Guardar
      v-data-table.elevation-1(:headers='headers' :items='record' :search='search')
        template(v-slot:items='props')
          td {{ props.item.código }}
          td {{ props.item.nombre }}
          td.justify-center.layout.px-0
            v-btn(color='secondary' icon @click='editItem(props.item.key)')
              v-icon(small) far fa-edit
            v-btn(color='secondary' icon @click='deleteItem(props.item.key)')
              v-icon(small) far fa-trash-alt
</template>
<script>

import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Fecha de creación', value: 'createdAt' },
      { text:'Acciones',value:'actions' }
    ],
  }),
  methods:{
    ...mapActions({
      editItem: 'Motivos_de_traslado/get',
      deleteItem: 'Motivos_de_traslado/clean',
      save: 'Motivos_de_traslado/add',
      edit: 'Motivos_de_traslado/edit',
      clearForm: 'Motivos_de_traslado/clearForm',
    }),
  },
  computed:{
    title() { return this.Motivos_de_traslado.selectedKey == '' ? 'Registrar' : 'Crear' },
    ...mapGetters({
      record: 'Motivos_de_traslado/record',
    }),
    ...mapState({
      data: state => state.Motivos_de_traslado.data,
      Motivos_de_traslado: state => state.Motivos_de_traslado,
    })
  },
}
</script>